import React from 'react';
import clsx from 'clsx';
import type { LayoutProps } from '../types';

export const Layout = ({ children, className }: LayoutProps) => {
  return (
    <div className={clsx('min-h-screen ', className)}>
      <main className=' mx-auto'>{children}</main>
    </div>
  );
};
